import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@buildoutinc/blueprint-react/ui/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';

import LoadingSpinner from 'components/ui/loading_spinner';
import LeadForm from './form';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons';
import { fetchProjectListings } from './index/store/actions/leads';
import { hideLeadModal, hideLeadModalAlert } from './index/store/actions/ui';
import { updateLead } from './index/store/actions/leads';

export class LeadModal extends React.Component {
  static propTypes = {
    availableDatabaseOptions: PropTypes.array.isRequired,
    errorMessage: PropTypes.string,
    hideLeadModal: PropTypes.func.isRequired,
    hideLeadModalAlert: PropTypes.func.isRequired,
    lead: PropTypes.object,
    leadReferralSources: PropTypes.array,
    leadStatuses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired
    })).isRequired,
    show: PropTypes.bool.isRequired,
    showAlert: PropTypes.bool.isRequired,
    updateLead: PropTypes.func.isRequired
  };

  state = {
    listings: null
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.lead && this.props.lead && this.props.show) {
      fetchProjectListings(this.props.lead.id).then((listings) => {
        this.setState({ listings });
      });
    } else if (prevProps.lead && !this.props.lead) {
      this.setState({ listings: null });
    }
  }

  updateLead = (leadData) => {
    const { id, projectId } = this.props.lead;
    leadData = { ...leadData, id };
    this.props.updateLead(projectId, leadData);
  };

  render() {
    return (
      <Modal open={this.props.show} onClose={this.props.hideLeadModal}>
        <Modal.Content className="overflow-visible">
          <Modal.Header>
            <Modal.Title className="d-flex gap-2 align-items-center">
              <FontAwesomeIcon className="text-primary" icon={faUserPlus} />
              Update Lead
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderBody()}
          </Modal.Body>
        </Modal.Content>
      </Modal>
    );
  }

  renderBody() {
    if (!this.props.lead) return;
    if (!this.state.listings) return <LoadingSpinner addBottomBuffer/>;

    return (
      <LeadForm
        availableDatabaseOptions={this.props.availableDatabaseOptions}
        condoListings={this.state.listings.filter(l => l.type === 'CondoListing')}
        errorMessage={this.props.errorMessage}
        hideLeadModal={this.props.hideLeadModal}
        hideLeadModalAlert={this.props.hideLeadModalAlert}
        lead={this.props.lead}
        leadReferralSources={this.props.leadReferralSources}
        leadStatuses={this.props.leadStatuses}
        leaseChecked={true}
        leaseSpaceListings={this.state.listings.filter(l => l.type === 'LeaseSpaceListing')}
        lotListings={this.state.listings.filter(l => l.type === 'LotListing')}
        projectId={this.props.lead.projectId}
        saleChecked={true}
        saleListing={this.state.listings.find(l => l.type === 'SaleListing')}
        show={this.props.show}
        showAlert={this.props.showAlert}
        useVaultGates={this.props.lead.useVaultGates}
        onSave={this.updateLead}
      />
    );
  }
}

const mapStateToProps = ({ availableDatabaseOptions, ui }) => ({
  availableDatabaseOptions,
  errorMessage: ui.errorMessage,
  lead: ui.lead,
  show: ui.showModal,
  showAlert: ui.showModalAlert
});

const actions = { hideLeadModal, hideLeadModalAlert, updateLead };

export default connect(mapStateToProps, actions)(LeadModal);
